export default __webpack_public_path__ + "8d38cd13cfcdfbc9066e843248d4e28b.svg";